module.exports = __webpack_public_path__ + "static/img/jianjie.eed61736.gif";